import React from 'react';
import CustomCursor from '../../Global/Cursor';
import Preloader from '../../Global/Preloader'
import Header from '../../Global/Header1';
import PageHeader from '../MenPortfolio/PageHeader';
import Portfolio from '../MenPortfolio/Portfolio';
import Cta from '../../Global/Cta'
import Footer from '../../Global/Footer1';
import GoToTop from '../../Global/GoToTop';

const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <PageHeader />
            <Portfolio />
            <Cta />
            <Footer />
            <GoToTop />
        </>
    )
}

export default Main
